export const ancillaryAction={
    SAVEANCILLARYDATA:"SAVEANCILLARYDATA",
    ADDBAG:"ADDBAGS",
    MINUSBAG:"MINUSBAG",
    INITIALIZESATE:"INITIALIZESATE",
    ADDTOCART:"ADDTOCART",
    REMOVEFROMCART:"REMOVEFROMCART"
}